import * as React from "react";
import { ReviewJurisdiction } from "../services/reviewStreamingService";

interface JurisdictionBubbleProps {
  jurisdiction: ReviewJurisdiction;
  timestamp?: string;
}

const JurisdictionBubble: React.FC<JurisdictionBubbleProps> = ({ jurisdiction, timestamp }) => {
  const confidence = jurisdiction.confidence ? jurisdiction.confidence.toLowerCase() : "low";
  const confidenceClass = confidence === "high" || confidence === "medium" ? confidence : "low";

  return (
    <div className="message assistant">
      <div className="message-avatar">
        <svg width="16" height="16" viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="3">
          <path d="M50 16H30a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h24a6 6 0 0 0 6-6V26l-10-10z" />
          <polyline points="50 16 50 26 60 26" />
          <line x1="34" y1="38" x2="50" y2="38" />
          <line x1="34" y1="48" x2="50" y2="48" />
        </svg>
      </div>
      <div className="message-content">
        <div className="message-bubble jurisdiction-bubble">
          <div className="jurisdiction-bubble-header">
            <span className="jurisdiction-bubble-title">Jurisdiction</span>
          </div>
          <div className="jurisdiction-bubble-main">
            <span className="jurisdiction-bubble-primary">{jurisdiction.primary || "Unknown"}</span>
            <span className={`jurisdiction-bubble-confidence ${confidenceClass}`}>{jurisdiction.confidence || "low"}</span>
          </div>
          {jurisdiction.basis && <div className="jurisdiction-bubble-basis">{jurisdiction.basis}</div>}
        </div>
        {timestamp && <div className="message-time">{timestamp}</div>}
      </div>
    </div>
  );
};

export default JurisdictionBubble;
